import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import Switch from '@ui/switch/switch';

export default function SingleUseRegistrationToggle() {
  const dispatch = useAppDispatch();
  const { courseOn, registrationSettings } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const linkLimit = registrationSettings?.emailLinkLimit;
  const confirmationRequired = registrationSettings?.registrationConfirmation;

  const toggleEmailLinkLimit = (value: number | null, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      emailLinkLimit: on ? 1 : null,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex ai-center jc-space-between">
      <div className="flex ai-center gap-8">
        <Text tag="h6" className="H6">
          Single Use Magic Links
        </Text>
      </div>
      <Switch
        value={linkLimit ?? null}
        on={courseOn ? false : !!linkLimit}
        onClick={toggleEmailLinkLimit}
        disabled={courseOn || !confirmationRequired || !registrationSettings || savingWorkingProject}
      />
    </Container>
  );
}
